/*
 materialize Pagination v0.2.2
 http://mirjamsk.github.io/materialize-pagination/

 Sample usage:
 $('#pagination').materializePagination({
 align: 'left',
 lastPage:  10,
 firstPage:  1,
 urlParameter: 'page',
 useUrlParameter: true,
 onClickCallback: function(requestedPage){
 console.log('Requested page is '+ requestedPage)
 }
 });
 */
export default function () {
  (function ($, window, document) {
    const MaterializePagination = function (elem, options) {
      this.$elem = $(elem)
      this.options = options
      this.$container = null
      this.$prevEllipsis = null
      this.$nextEllipsis = null
      this.currentPage = null
      this.visiblePages = []
      this.maxVisiblePages = 5
    }

    MaterializePagination.prototype = {
      defaults: {
        align: 'center',
        lastPage: 1,
        firstPage: 1,
        urlParameter: 'page',
        useUrlParameter: true,
        onClickCallback: function () {
        }
      },

      init: function () {
        // Combine defaults with user-specified options
        this.config = $.extend({}, this.defaults, this.options)
        // Get page defined by the urlParameter
        const requestedPage = this.config.useUrlParameter ? this.parseUrl() : this.config.firstPage
        // Create initial pagination and add it to the DOM
        if (this.createPaginationBase(requestedPage)) this.bindClickEvent()
      },

      createPaginationBase: function (requestedPage) {
        if (isNaN(this.config.firstPage) || isNaN(this.config.lastPage)) {
          return false
        } else if (this.config.firstPage > this.config.lastPage) {
          return false
        }
        this.config.firstPage = parseInt(this.config.firstPage, 10)
        this.config.lastPage = parseInt(this.config.lastPage, 10)
        this.currentPage = this.config.firstPage - this.maxVisiblePages

        this.$container = $('<div>')
          .addClass('pagination')
          .addClass(this.config.align + '-align')

        this.$prevEllipsis = this.util.Ellipsis()
        this.$nextEllipsis = this.util.Ellipsis()

        const $firstPage = this.util.createPage(this.config.firstPage)
        const $prevChevron = this.util.createChevron('prev')
        const $nextChevron = this.util.createChevron('next')

        this.$container.append($prevChevron)
          .append($firstPage)
          .append(this.$prevEllipsis.$elem)
          .append(this.$nextEllipsis.$elem)
          .append($nextChevron)

        if (this.config.lastPage > this.config.firstPage) {
          const $lastPage = this.util.createPage(this.config.lastPage)
          $lastPage.insertBefore($nextChevron)
        }

        this.requestPage(requestedPage)
        this.renderActivePage()
        this.$elem.append(this.$container)
        return true
      },

      requestPage: function (requestedPage) {
        switch (requestedPage) {
          case this.currentPage:
            return
          case this.currentPage - 1:
            this.requestPrevPage()
            break
          case this.currentPage + 1:
            this.requestNextPage()
            break
          default:
            this.requestPageByNumber(requestedPage)
        }
        this.config.onClickCallback(this.currentPage)
        this.renderActivePage()

        if (this.config.useUrlParameter) this.updateUrlParam(this.config.urlParameter, this.currentPage)
      },

      requestPrevPage: function () {
        this.currentPage -= 1
        this.visiblePages.pop().remove()
        this.visiblePages.unshift(this.insertPrevPaginationComponent(this.currentPage - 1))
      },

      requestNextPage: function () {
        this.currentPage += 1
        this.visiblePages.shift().remove()
        this.visiblePages.push(this.insertNextPaginationComponent(this.currentPage + 1))
      },

      requestPageByNumber: function (requestedPage) {
        this.purgeVisiblePages()
        this.currentPage = requestedPage
        this.visiblePages.push(this.insertNextPaginationComponent(this.currentPage - 1))
        this.visiblePages.push(this.insertNextPaginationComponent(this.currentPage))
        this.visiblePages.push(this.insertNextPaginationComponent(this.currentPage + 1))
      },

      renderActivePage: function () {
        this.renderEllipsis()
        this.$container.find('a.active').removeClass('active')
        const currentPageComponent = $(this.$container.find('[data-page="' + this.currentPage + '"]')[0])
        currentPageComponent.addClass('active')
      },

      renderEllipsis: function () {
        if (this.currentPage > this.maxVisiblePages - this.config.firstPage - 1) {
          this.$prevEllipsis.show()
        } else {
          this.$prevEllipsis.hide()
        }

        if (this.currentPage < this.config.lastPage - 2) {
          this.$nextEllipsis.show()
        } else {
          this.$nextEllipsis.hide()
        }
      },

      bindClickEvent: function () {
        const self = this
        this.$container.on('click', 'a', function () {
          const requestedPage = self.sanitizePageRequest($(this).data('page'))
          self.requestPage(requestedPage)
        })
      },

      insertPrevPaginationComponent: function (pageNumber) {
        if (pageNumber > this.config.firstPage && pageNumber < this.config.lastPage) {
          const $paginationComponent = this.util.createPage(pageNumber)
          return $paginationComponent.insertAfter(this.$prevEllipsis.$elem)
        }
        return $('')
      },

      insertNextPaginationComponent: function (pageNumber) {
        if (pageNumber > this.config.firstPage && pageNumber < this.config.lastPage) {
          const $paginationComponent = this.util.createPage(pageNumber)
          return $paginationComponent.insertBefore(this.$nextEllipsis.$elem)
        }
        return $('')
      },

      sanitizePageRequest: function (pageData) {
        let requestedPage = this.config.firstPage

        if (pageData === 'prev') {
          requestedPage = this.currentPage === this.config.firstPage ? this.currentPage : this.currentPage - 1
        } else if (pageData === 'next') {
          requestedPage = this.currentPage === this.config.lastPage ? this.currentPage : this.currentPage + 1
        } else if (!isNaN(pageData) && pageData >= this.config.firstPage && pageData <= this.config.lastPage) {
          requestedPage = parseInt(pageData, 10)
        }
        return requestedPage
      },

      purgeVisiblePages: function () {
        const size = this.visiblePages.length
        for (let page = 0; page < size; page += 1) {
          this.visiblePages.pop().remove()
        }
      },

      parseUrl: function () {
        const requestedPage = this.getUrlParamByName(this.config.urlParameter) || this.config.firstPage
        return this.sanitizePageRequest(requestedPage)
      },

      getUrlParamByName: function (name) {
        name = name.replace(/[[\]]/g, '\\$&')
        const url = window.location.href
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        const results = regex.exec(url)
        if (!results) return null
        if (!results[2]) return ''
        return decodeURIComponent(results[2].replace(/\+/g, ' '))
      },

      updateUrlParam: function (key, value) {
        const urlQueryString = document.location.search
        const newParam = key + '=' + value
        let params = '?' + newParam

        if (urlQueryString) { // If the "search" string exists, then build params from it
          const keyRegex = new RegExp(`([?&])${key}[^&]*`)

          if (urlQueryString.match(keyRegex) !== null) { // If param exists already, update it
            params = urlQueryString.replace(keyRegex, '$1' + newParam)
          } else { // Otherwise, add it to end of query string
            params = urlQueryString + '&' + newParam
          }
        }
        window.history.pushState('', '', params)
      },

      util: {
        createPage: function (pageData) {
          return $('<a>')
            .text(pageData)
            .attr('data-page', pageData)
        },
        createChevron: function (type) {
          const direction = type === 'next' ? 'right' : 'left'

          const $icon = $('<i>')
            .addClass('material-icons icon-grey')
            .text('chevron_' + direction)

          return this.createPage(type).text('')
            .attr('data-page', type)
            .append($icon)
        },
        Ellipsis: function () {
          const $ellipsis = $('<span>')
          $ellipsis.text('...')
          $ellipsis.addClass('hide gap')
          return {
            $elem: $ellipsis,
            isHidden: true,
            show: function () {
              this.isHidden = false
              this.$elem.removeClass('hide')
            },
            hide: function () {
              this.isHidden = true
              this.$elem.addClass('hide')
            }
          }
        }
      }
    }

    MaterializePagination.defaults = MaterializePagination.prototype.defaults
    $.fn.materializePagination = function (options) {
      return this.each(function () {
        new MaterializePagination(this, options).init()
      })
    }
  })(window.jQuery, window, document) // eslint-disable-line
}
